/**
 * Its own module rather than living beside the table: the columns hook needs the id to spot the
 * user's own line, and reading it off `rake-race-table` — which imports that very hook — made
 * the two circular.
 */
export const USER_RANK_ROW = 'user-rank-row'
